import { UserCustomFilter } from 'core/utils/types/user-custom-filter.type';
import { Params } from 'react-router-dom';
import { DEACTIVATE_FILTER_PARAM } from './create-filter-context.constants';

export const isDefaultInactiveView = (params: Readonly<Params<string>>) => params.filter === DEACTIVATE_FILTER_PARAM;

export const isDefaultView = (params: Readonly<Params<string>>) =>
    !params.filter || params.filter === DEACTIVATE_FILTER_PARAM;

export function getFilterFromUrl<T>(
    locationFilter: string | undefined,
    sideMenuEntries: UserCustomFilter<unknown>[]
): UserCustomFilter<T> | undefined {
    if (!locationFilter || locationFilter === DEACTIVATE_FILTER_PARAM) {
        return undefined;
    }
    const filterSelected = sideMenuEntries.find((filter) => filter.id === locationFilter);
    // fields is cast to T because each module's outlet is scoped to its own filter type
    return filterSelected
        ? {
              id: filterSelected.id,
              name: filterSelected.name,
              fields: filterSelected.fields as T,
              sorting: filterSelected.sorting ?? {},
          }
        : undefined;
}
